module.exports = __webpack_public_path__ + "img/gb.85a97dab.svg";